module.exports = __webpack_public_path__ + "static/media/feed-liked.14eac8bd.svg";